<!--
 * @Author: your name
 * @Date: 2021-08-10 17:10:31
 * @LastEditTime: 2021-09-26 11:46:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /b_c_i18n/src/components/OrderAbnormalInfo/index.vue
-->
<template>
  <div class="order-abnormal">
    <div class="order-tips__icon" v-if="getIcon">
      <img :src="getIcon" alt="" class="tips__icon-img" />
    </div>
    <div class="order-title" v-if="orderabnormalInfo.title">
      <RichText :text="orderabnormalInfo.title" />
      <img
        class="status-icon finger-style"
        v-if="$useOptionChain(orderabnormalInfo, 'ruleNotice.icon')"
        :src="$useOptionChain(orderabnormalInfo, 'ruleNotice.icon')"
        alt=""
        @click="goIconUrl('ruleNotice', getRuleNoticeUrl)"
      />
    </div>
    <div class="order-content" v-if="orderabnormalInfo.content">
      <RichText :text="orderabnormalInfo.content" />
    </div>
    <div
      class="order-word-chain finger-style"
      v-if="$useOptionChain(orderabnormalInfo, 'wordChain.text')"
      @click="goIconUrl('wordChain', getWordChainUrl)"
    >{{ $useOptionChain(orderabnormalInfo, 'wordChain.text') }}<i class="icon-outline_entrance"></i>
    </div>
    <div
      class="order-btn"
      v-if="
        $useOptionChain(orderabnormalInfo, 'btns') &&
          $useOptionChain(orderabnormalInfo, 'btns').length
      "
    >
      <div
        class="btn-list"
        v-for="(item, index) in $useOptionChain(orderabnormalInfo, 'btns')"
        :key="index"
      >
        <el-button
          :dark="item.disable == 1"
          :disabled="item.disable == 1"
          @click="openPayDialog(item)"
          >{{ item.name }}</el-button
        >
      </div>
    </div>
    <PayMethods
      v-model="payMethodsVisible"
      :titleName="titleName"
      :money="getMoney"
      @confrimPay="confrimPay"
    />
  </div>
</template>

<script>
import RichText from '@/components/RichText';
import PayMethods from '@/components/PayMethods';
import status_1 from '@/assets/images/didi/cardStatus/status_1.png';
import status_2 from '@/assets/images/didi/cardStatus/status_2.png';
import status_3 from '@/assets/images/didi/cardStatus/status_3.png';
import status_4 from '@/assets/images/didi/cardStatus/status_4.png';
import status_5 from '@/assets/images/didi/cardStatus/status_5.png';
export default {
  name: 'OrderAbnormal',
  components: {
    RichText,
    PayMethods,
  },
  computed: {
    getIcon() {
      // 0:待支付
      // 1：用户发起退款申请
      // 2: 用户申请退款成功
      // 3: 用户申请退款失败
      // 4: 代购订单有缺货场景
      // 5: 现金单欠款待支付
      // 6: 现金单欠款支付中
      // 7: 被动取消订单
      // 8: 代购缺货B取消
      // 9: 欠款单支付完成
      const IMG = {
        0: '',
        1: status_2,
        2: status_3,
        3: status_2,
        4: '',
        5: status_1,
        6: status_1,
        7: status_5,
        8: '',
        9: status_1
      };
      return IMG[this.orderabnormalInfo?.status];
    },
    getRuleNoticeUrl() {
      return this.orderabnormalInfo?.ruleNotice?.url;
    },
    getWordChainUrl() {
      return this.orderabnormalInfo?.wordChain?.url;
    },
    getMoney() {
      return this.orderabnormalInfo?.debtInfo?.unpaidMoneyDisplay;
    },
  },
  props: {
    orderabnormalInfo: Object,
  },
  data() {
    return {
      payMethodsVisible: false,
      titleName: '',
      money: '',
    };
  },
  methods: {
    goIconUrl(type, url) {
      this.$emit('goIconUrl', {
        type,
        url,
      });
    },
    openPayDialog(val) {
      // 1:弹toast，2:弹框，3:跳转h5，4:调接口
      if (val?.action == 1) {
        if (this.isH5) {
        } else {
          this.$message({
            message: val?.alert,
            type: 'success',
          });
        }
      } else if (val?.action == 2) {
        this.titleName = val?.name;
        this.payMethodsVisible = true;
      } else if (val?.action == 3) {
        window.location.url = val?.url;
      } else if (val?.action == 4) {
        // 去哪里？？？
      }
    },
    confrimPay(item) {
      this.$emit('confrimPay', item);
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
